import React from 'react';
import ModalFormUI from './../../../widgets/form/ModalFormUI';
import InputTextSF from './../../../widgets/form/InputTextSF';
import InputNameSF from './../../../widgets/form/InputNameSF';
import InputPhoneNumberUI from './../../../widgets/form/InputPhoneNumberUI';

const VendorUpdateModalUI = ({
    context, messageList, successMsg, errorList,
    // modes
    updateMode, submitted,
    // event handlers
    onConfirmUpdateClick, onCancelClick, setErrorList,
    // vendorName attributes and methods
    vendorName, onVendorNameChange, vendorNameError, setVendorNameError,
    // contact attributes and methods
    firstName, lastName, firstNameError, lastNameError, setFirstNameError, setLastNameError, onFirstNameChange, onLastNameChange,
    // phoneNumber attributes and methods
    phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
    // email attributes and methods
    email, onEmailChange, emailError, setEmailError
}) =>
    <ModalFormUI
        context={context}
        messageList={messageList}
        titleMessageKey='c_update_vendor'
        buttonMessageKey='c_update'
        cancelMessageKey='c_cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        setErrorList={setErrorList}
        errorList={errorList}
        onSubmit={onConfirmUpdateClick}
        busy={submitted}
    >
        <InputTextSF type='text' name='vendorName' required={true}
            messageList={messageList} labelKey='c_vendor_name'
            value={vendorName} onChange={onVendorNameChange}
            error={vendorNameError}
            setError={setVendorNameError}
            autoFocus={true}
        />
        <InputNameSF type='name' name='name' firstName={firstName} lastName={lastName} required={true}
            messageList={messageList} labelKey='c_name'
            firstNameError={firstNameError} lastNameError={lastNameError}
            setFirstNameError={setFirstNameError} setLastNameError={setLastNameError}
            onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange} />

        <InputPhoneNumberUI name='phoneNumber' required={true}
            messageList={messageList} labelKey='c_phone_number'
            value={phoneNumber} onChange={onPhoneNumberChange}
            error={phoneNumberError}
            setError={setPhoneNumberError}
        />

        <InputTextSF type='text' name='email' required={true} maxLength={64}
            messageList={messageList} labelKey='c_email'
            value={email} onChange={onEmailChange}
            error={emailError}
            setError={setEmailError}
        />
    </ModalFormUI>

export default VendorUpdateModalUI;
